import { consola } from 'consola'
import { useMaxWebApp } from '@shared/lib'
import { useMaxWebAppAuth } from '~/features/auth/model'

const logger = consola.withTag('max-webapp')

/**
 * Инициализация мини-приложения MAX (WebApp).
 *
 * Срабатывает ТОЛЬКО внутри MAX (детект по WebAppData в URL) — на обычном сайте no-op.
 * Грузит Bridge и выполняет авто-логин по initData. Запуск не блокирует рендер:
 * UI стартует как гостевой и «доезжает» до авторизованного, когда вход завершится.
 */
export default defineNuxtPlugin(() => {
  const max = useMaxWebApp()
  if (!max.isMaxEnv()) return

  logger.info('Запуск внутри MAX — инициализация мини-приложения')

  // Не блокируем загрузку приложения ожиданием сети/контакта.
  void (async () => {
    try {
      await max.ensureBridge()
      // Предупреждаем о потере данных при закрытии (например, незавершённый заказ).
      max.enableClosingConfirmation()
      await useMaxWebAppAuth().tryAutoLogin()
    } catch (error) {
      logger.warn('Ошибка инициализации MAX мини-приложения:', error)
    }
  })()
})
